export const id = `
  id
  idInc
  idVendor
  sk
`;

export const basic = `
  bankId
  createdAt
  description
  isUnlisted
  visibility
  maturity
  name
  schemaVersion
  type
  updatedAt
  version
  workspaceId
`;

export const meta = `
  blooms
  difficulty
  dok
  excerpt
  flesch
  grade
  language
  lexile
  lexileMax
  lexileMin
  parccTextComplexity
  rmm
  subject
  wordCount
`;

export const item = `
  difficulty
  scoringMethod
  answerDistribution
`;

export const examContent = `
  content {
    forms {
      name
      type
      config
      sections {
        name
        type
        config
        questionIds
      }
    }
  }
`;

export const canvas = `
id
type
interactionType
content
config
scoring
`;

export const itemContent = `
  content { 
    canvas {
      ${canvas}
    }
  }
`;

export const context = `
id
idInc
idVendor
sk
type
version
maturity
content {
  body
}
file {
  bucket
  name
  key
  size
}
name
description
createdAt
updatedAt
`;

export const contexts = `
contextIds
contexts {
  items {
    ${context}
  }
  nextToken
}
`;

export const passageContent = `
  content { 
    body
  }
`;

export const passage = `
  lexile
  lexileMin
  lexileMax
  rmm
  flesch
  wordCount
  parccTextComplexity
`;

export const issue = `
  resolutionType
  resolutionText
  resolutionAt
  resolutionUserId
  maturity
  priority
`;

export const alignmentItemBasic = `
  id
  sk
  idPublisher
  abbreviation
  scope
  authorityId
`;

export const alignmentsAbbrs = `
  alignments {
    items {
      ${alignmentItemBasic}
      content
    }
  }
`;

export const alignments = `
  alignments {
    items {
      ${alignmentItemBasic}
      content
    }
  }
`;

export const reviews = `
reviews {
  maturity
  creatorId
  creator {
    firstName
    lastName
    avatarHash
  }
}
`;

export const tags = `
tags {
  key
  type
  value
}
`;

export const file = `
file {
  name
  region
  bucket
  key
  size
  mimetype
  format
  extension
}
`;

export const items = (fields: string) => `
items {
  ${fields}
}
nextToken
`;

export const getRubricContent = `
id
sk
workspaceId
content {
  rubric
}
`;

export const getPassageContent = `
id
sk
schemaVersion
content {
  body
}
`;
